import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Text from '../common/text/Text';

const Heading = props => {
    const { className, ...otherProps } = props;
    return (
        <Text
            as="h2"
            className={cx('pz-heading', className)}
            size={14}
            transform="uppercase"
            weight="bold"
            {...otherProps}
        />
    );
};

Heading.displayName = 'Heading';

Heading.propTypes = {
    className: PropTypes.string
};

export default Heading;
